import { Component, OnInit } from '@angular/core';
import { FooterLink, SocialMediaLink } from './footer.types';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss']
})
export class FooterComponent implements OnInit {
  content: FooterLink[] = [];
  currentYear = new Date().getFullYear();
  phoneNumber = '1-866-216-7708';
  hours = 'Weekdays: 6 a.m. to 4:30 p.m. PT | 9 a.m. to 7:30 p.m. ET';
  header = 'GENERAL SUPPORT';
  emailText = 'Send us a message';
  emailLink = 'mailto:benefitsportalsecurity@symetra.com?subject=Benefits%20Portal%20Customer%20Support';
  socialMediaContent: SocialMediaLink[] = [
    {
      name: 'facebook',
      url: 'https://www.facebook.com/Symetra'
    },
    {
      name: 'linkedin',
      url: 'https://www.linkedin.com/company/symetra'
    },
    {
      name: 'instagram',
      url: 'https://www.instagram.com/symetra'
    }
  ];

  getContent() {
    return [
      { name: 'About Symetra', url: 'https://www.symetra.com/about-us/about-symetra' },
      { name: 'Privacy', url: 'https://www.symetra.com/admin-pages/privacy' },
      { name: 'Security', url: 'https://www.symetra.com/admin-pages/security' },
      { name: 'CA Privacy Notice', url: 'https://www.symetra.com/admin-pages/CCPA/' },
      { name: 'Terms & Conditions', url: 'https://www.symetra.com/admin-pages/terms-conditions-symetra-online/' },
      { name: 'Legal Disclosures', url: 'https://www.symetra.com/admin-pages/legal-disclosures' },
      { name: 'Business Continuity', url: 'https://www.symetra.com/admin-pages/business-continuity' }
    ];
  }

  get contactInfo() {
    return {
      hours: this.hours,
      tel: this.phoneNumber
    };
  }

  ngOnInit(): void {
    this.content = this.getContent();
  }
}
